module.exports = __webpack_public_path__ + "img/pin-motorcycle.96f93e19.svg";